<template>
  <dl class="itinerary-section-item-details">
    <template v-if="isDatesPresent">
      <dt>Dates</dt>
      <dd>{{ dateValues }}</dd>
    </template>

    <template v-if="isTimeHoursPresent">
      <dt>Time</dt>
      <dd v-if="entity.openingHourSeasons && entity.openingHourSeasons.length">
        <ItinerarySectionItemOpeningHourSeasons :seasons="entity.openingHourSeasons" />
      </dd>
      <dd v-else-if="startTime">{{ timeValues }}</dd>
    </template>

    <template v-if="entity.address">
      <dt>Address</dt>
      <dd>{{ entity.address }}</dd>
    </template>
  </dl>
</template>

<script>
import { formatDate, formatTime } from '@/helpers/dateTimeHelper';

export default {
  components: {
    ItinerarySectionItemOpeningHourSeasons: () =>
      import('@/components/itinerary/ItinerarySectionItemOpeningHourSeasons.vue'),
  },
  props: {
    entity: {
      type: Object,
      required: true,
    },
  },

  computed: {
    isDatesPresent() {
      return this.entity.earliestStartDate;
    },
    isTimeHoursPresent() {
      return this.isDatesPresent || (this.entity.openingHourSeasons && this.entity.openingHourSeasons.length);
    },
    dateValues() {
      return this.startDate + (this.startDate !== this.endDate ? ` - ${this.endDate}` : '');
    },
    timeValues() {
      return this.startTime + (this.startTime !== this.endTime ? ` - ${this.endTime}` : '');
    },
    startDate() {
      return formatDate(this.entity.earliestStartDate);
    },
    startTime() {
      return formatTime(this.entity.earliestStartDate);
    },
    endDate() {
      return formatDate(this.entity.latestEndDate);
    },
    endTime() {
      const endDate = this.entity.latestEndDate;

      return this.isDatesPresent && endDate ? formatTime(endDate) : '';
    },
  },
};
</script>

<style lang="scss" scoped>
@use '@/assets/scss/variables-site/variables' as vars;

.itinerary-section-item-details {
  display: grid;
  grid-template-columns: minmax(0, max-content) minmax(70%, 1fr);
  grid-auto-rows: minmax(24px, max-content);
  gap: 8px 16px;
  font-size: 14px;

  @media (min-width: vars.$mobile-break-point + 1px) {
    font-size: 16px;
  }

  span {
    display: block;
  }
}
</style>
